/* Map and Contact Details Block JS File */
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import 'debug.addIndicators';
import TimelineMax from 'TimelineMax';
import slick from 'slick-carousel';
$(document).ready(function() {
	if ($(".map-and-contact-details-wrapper .section-map-wrapper").length) {
		$(".section-map-slick").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			mobileFirst: true,
			pauseOnDotsHover: false,
			pauseOnFocus: false,
			pauseOnHover: true,
			arrows: false,
			dots: false,
			fade: true,
			draggable: true,
			asNavFor: '.section-map-slick-nav',
		});

		$(".section-map-slick-nav").slick({
			slidesToShow: $('.section-map-slick-nav').attr('data-number'),
			slidesToScroll: 1,
			focusOnSelect: true,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			asNavFor: '.section-map-slick',
		});
	}

	if ($('.map-and-contact-details-wrapper .map-parallax').length) {
		const mapAndContactBackgroundTween = TweenMax.fromTo(".map-and-contact-details-wrapper .map-parallax", 1, { y: '-25%' }, { y: '20%' });
		const mapAndContactBackgroundController = new ScrollMagic.Controller();
		const mapAndContactBackgroundScene = new ScrollMagic.Scene({
			triggerElement: ".map-and-contact-details-wrapper .map-parallax",
			triggerHook: "onEnter",
			duration: "300%"
		}).setTween(mapAndContactBackgroundTween);

		mapAndContactBackgroundScene.addTo(mapAndContactBackgroundController);
	}
});
